/**
 * Dragging your own Pokémon in play, not cards from the hand: the active Pokémon down onto a benched one to retreat
 * to it, or a benched one up to the active spot. Up means whatever the game wants right now: a new active Pokémon
 * after a knockout, the one to switch in after an attack like Whirlwind, or, on your turn, a retreat to it.
 */

/** What's being dragged (Drag/dropTargets setDragging), so the spots it can go to light up. */
export const ACTIVE_TO_BENCH = 'active-to-bench';
export const BENCHED_TO_ACTIVE = 'benched-to-active';

/** What going up to the active spot does. */
export const PROMOTE = 'promote';
export const SWITCH_IN_OWED = 'switch-in-owed';
/** Starts a retreat to it (the energy to discard may be asked first). */
export const RETREAT = 'retreat';
/** A retreat already started with the Retreat button, waiting for who switches in. */
export const FINISH_RETREAT = 'finish-retreat';

/**
 * Whether you can retreat right now: the server allows it (its option's reason is null) on your main phase, and
 * nothing else is being picked on the board.
 */
export const canRetreat = ({ isMainPhase, retreatReason, boardChoice, retreatFlowing }) => (
  isMainPhase && retreatReason === null && boardChoice === null && !retreatFlowing
);

/** What dragging a benched Pokémon up to the active spot does now, or null when it can't go. */
export function upToActive({ hasActive, switchInOwed, pickingSwitchIn, canRetreatNow }) {
  if (!hasActive) {
    return PROMOTE;
  }
  if (switchInOwed) {
    return SWITCH_IN_OWED;
  }
  if (pickingSwitchIn) {
    return FINISH_RETREAT;
  }
  return canRetreatNow ? RETREAT : null;
}
